import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { SiteAction } from '../../actions/SiteAction';
import { RayForm, RayMaps } from '../../components/common';
import { SpecialityTypes } from '../../config/RayCodes';
import { CountryCode } from '../../config';
import { ModalConfirm } from '../../components/common/ModalConfirm';
import { Translate as t } from '../../config/Translate';
import { EditSaveCancelBar } from '../../components/common/Buttons';
import { useBatchEdit } from '../../hooks/useBatchEdit';

const SITE_FIELDS = ['sitename', 'speciality', 'tel', 'fax', 'email', 'hp', 'address', 'addressExtra', 'zipcode', 'country', 'website'];

const toDraft = (site) => {
    const obj = {};
    SITE_FIELDS.forEach(n => { obj[n] = site?.[n]; });
    return obj;
};

const AdminSiteInfo_Site = ({ site, GetSite, UpdateSiteInfo, editable, cancelcallback = null }) => {

    const [isMapOk, setIsMapOk] = useState(true);
    const [updateModalInfo, setUpdateModalInfo] = useState({});
    const [pos, setPos] = useState({});

    const { draft, editing, saving, errors, formKey, onChange, onEdit, onSave, onCancel } = useBatchEdit({
        source: site,
        toDraft,
        save: (changed) => UpdateSiteInfo(site?._id, changed),
        editable: !!editable,
        entry: 'header',
        onClose: cancelcallback
    });
    const fieldEditable = editing;

    const form_controls = [
        {
            title: "", items: [
                { type: "input", name: "sitename", label: t('site.field.siteName'), val: draft.sitename, required: true, isEditable: fieldEditable },
                { type: "select", name: "speciality", label: t('site.field.specialty'), val: draft.speciality, list: SpecialityTypes, isEditable: fieldEditable }
            ]
        },
        {
            title: "", items: [
                { type: "tel", name: "tel", label: t('common.field.tel'), val: draft.tel, isEditable: fieldEditable },
                { type: "tel", name: "fax", label: t('common.field.fax'), val: draft.fax, isEditable: fieldEditable }
            ]
        },
        {
            title: "", items: [
                { type: "email", name: "email", label: t('common.field.email'), val: draft.email, isEditable: fieldEditable },
                { type: "tel", name: "hp", label: t('common.field.mobile'), val: draft.hp, isEditable: fieldEditable }
            ]
        },
        {
            title: "", items: [
                { type: "input", name: "address", label: t('common.field.address'), size: 12, val: draft.address, isEditable: fieldEditable },
            ]
        },
        {
            title: "", items: [
                { type: "input", name: "addressExtra", label: "Address Extra", size: 12, val: draft.addressExtra, isEditable: fieldEditable }
            ]
        },
        {
            title: "", items: [
                { type: "tel", name: "zipcode", label: t('common.field.zipCode'), val: draft.zipcode, isEditable: fieldEditable },
                { type: "select", name: "country", label: t('common.field.country'), val: draft.country, list: CountryCode, isEditable: fieldEditable }
            ]
        },
        {
            title: "", items: [
                { type: "input", name: "website", label: t('common.field.website'), val: draft.website, size: 12, isEditable: fieldEditable }
            ]
        }
    ]

    const mapOk = (bl) => {
        setIsMapOk(bl);
    }

    const updateSiteLocation = (e) => {
        UpdateSiteInfo(site._id, { lat: e.lat, lng: e.lng });
        setUpdateModalInfo({ ...updateModalInfo, showModal: false });
    }

    const callbackAddress = (e) => {
        setUpdateModalInfo({
            showModal: true,
            title: "Update site info?",
            content: "Do you want to update site location?",
            actions: [{ title: "Yes", callback: () => updateSiteLocation(e) }]
        });
    }

    useEffect(() => {
        setPos({
            lat: site.lat || 37.400671488676345,
            lng: site.lng || 127.10900008486625,
            isset: (site.lat && site.lng)
            // lat: parseFloat(site.coords[1]) || 37.400671488676345,
            // lng: parseFloat(site.coords[0]) || 127.10900008486625,
            // isset: (site.coords[1] && site.coords[0])
        });
    }, [site])

    return (
        <>
            <div className="ms-2 me-2">
                {!pos.isset && <div className='alert alert-danger rounded-0'>Not set site location. please update location.</div>}
                {(pos.lat && pos.lng && isMapOk) &&
                    <RayMaps
                        id="myMap"
                        options={{
                            zoom: 18,
                            draggable: true,
                            mapTypeControl: false,
                            streetViewControl: false,
                            rotateControl: false,
                            scaleControl: false,
                            zoomControl: false
                        }}
                        onMapLoad={map => {

                        }}
                        callback={(bl) => mapOk(bl)}
                        callbackAddress={callbackAddress}
                        country=""
                        Lat={pos.lat}
                        Lng={pos.lng}
                        markerList={[]}
                    />
                }
            </div>
            <RayForm
                key={formKey}
                controls={form_controls}
                handleChangeData={onChange}
                errors={errors} />
            <div className="ps-1 pe-1 mb-1">
                <EditSaveCancelBar
                    canEdit={!!editable}
                    editing={editing}
                    onEdit={onEdit}
                    onSave={() => onSave(form_controls)}
                    onCancel={onCancel}
                    saving={saving} />
            </div>
            <ModalConfirm
                isActionSheet={true}
                info={updateModalInfo}
                callbackClose={() => setUpdateModalInfo({ ...updateModalInfo, showModal: false })} />
        </>
    );
};

const mapDispatch = dispatch => ({
    UpdateSiteInfo: (_id, data) => dispatch(SiteAction.UpdateSiteInfo(_id, data))
})
export default connect(null, mapDispatch)(AdminSiteInfo_Site);